const FieldWrapper = ({ errorMessage, className, type, name, children }) => (
  <div
    hidden={type === "hidden"}
    className={className || "unchained-form-field"}
    aria-errormessage={
      typeof errorMessage === "string" ? errorMessage : undefined
    }
    aria-invalid={!!errorMessage}
    data-error-wrapper-for={name}
  >
    {children}
  </div>
);

export default FieldWrapper;
